import { useState } from 'react'

import useMediaQuery from '@equifax-ui/hooks/useMediaQuery'

import {
  HOME_FILTERS,
  HOME_SERVICES,
  POSTPAID_FILTERS,
  POSTPAID_SERVICES
} from './constants'

export const useSolutions = ({ variant }) => {
  const [activeFilterIndex, setActiveFilterIndex] = useState(0)
  const [visibleDetailsModal, setVisibleDetailsModal] = useState()

  const isMobile = useMediaQuery('screen and (max-width: 1024px)')

  const services = variant === 'home' ? HOME_SERVICES : POSTPAID_SERVICES
  const filters = variant === 'home' ? HOME_FILTERS : POSTPAID_FILTERS

  const visibleService = services[activeFilterIndex]

  const onSelectFilter = (index) => {
    setActiveFilterIndex(index)
  }

  return {
    filters,
    activeFilterIndex,
    visibleDetailsModal,
    visibleService,
    isMobile,
    onSelectFilter,
    setVisibleDetailsModal
  }
}
